(() => {
  document.addEventListener('glaskob:cart-added', event => {
    const items = event.detail?.items || (event.detail?.key ? [event.detail] : []);
    if (!items.some(item => item.key) || !window.routes?.cart_url || !window.quickOrderListStrings?.viewCart) return;
    const attach = () => {
      const content = document.querySelector('.custom-cart-view .cart_notification_content');
      if (!content) return false;
      if (content.querySelector('[data-glass-view-cart]')) return true;
      const link = document.createElement('a');
      link.href = window.routes.cart_url;
      link.className = 'button glass-view-cart';
      link.dataset.glassViewCart = '';
      link.textContent = window.quickOrderListStrings.viewCart;
      content.append(link);
      return true;
    };
    if (attach()) return;
    const observer = new MutationObserver(() => { if (attach()) observer.disconnect(); });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 5000);
  });
})();
